const table = {
    worksheetManageShare: [{
        name: 'USER EMAIL',
        key: 'shared_to__email',
        linkActive: false,
        link: ''
    },{
        name: 'SHORT NAME',
        key: 'shared_to__short_name',
        linkActive: false,
        link: ''
    }],
    worksheetShared: [{
        name: 'WORKSHEET NAME',
        key: 'worksheet__worksheet_name',
        link: 'dashboard/0/workSheet/',
        linkIdKey: 'worksheet_id',
        storeInLocal: {
            status: true,
            name: 'worksheetId'
        }
    },{
        name: 'SHARED BY',
        key: 'worksheet__assessment__participant__email',
        linkActive: false,
        link: ''
    },{
        name: 'ORIENTATION',
        key: 'worksheet__orientation__orientation_name',
        linkActive: false,
        link: ''
    },{
        name: 'ASSESSMENT DATE',
        key: 'worksheet__assessment__created',
        linkActive: false,
        link: ''
    }],
    worksheet: [{
        name: 'WORKSHEET NAME',
        key: 'worksheet_name',
        link: '',
        storeInLocal: {
            status: true,
            name: 'worksheetId'
        }       
    },
    {
        name: 'ORIENTATION',
        key: 'orientation__orientation_name',
        linkActive: false,
        link: '',
    },
    {
        name: 'ASSESSMENT DATE',
        key: 'assessment__created',
        linkActive: false,
        link: '',
    },
    {
        name: '',
        key: 'report_accesss',
        type: 'modalOpeners',
        modalData: [{
            id: 0,
            modalStyle: 'icon',
            iconClass: 'fas fa-pencil-alt',
            disabledKey: 'is_submited',
            disabledWhenBool: true,
            funcType: 'edit'
        }],
        modalStyle: 'icon',
        content: '',
        linkActive: false,
        link: ''
    }]
}

export default table;


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/worksheet/tableData.js